module.exports = __webpack_public_path__ + "img/万盛-重庆青山湖国家湿地公园@2x.3c0367c1.png";